export const TREE_LEVEL_STYLES: Record<
  number,
  {
    border: string;
    borderRadius: string;
    bgcolor: string;
    iconBg: string;
    iconColor: string;
    fontWeight: number;
    fontSize: string;
    minHeight: number;
    py: number;
    mb: number;
  }
> = {
  0: {
    border: '1px solid #e2e8f0',
    borderRadius: '8px',
    bgcolor: '#ffffff',
    iconBg: 'rgba(37, 99, 235, 0.08)',
    iconColor: '#2563eb',
    fontWeight: 600,
    fontSize: '0.8125rem',
    minHeight: 38,
    py: 0.25,
    mb: 0.75,
  },
  1: {
    border: '1px solid #e2e8f0',
    borderRadius: '7px',
    bgcolor: '#f8fafc',
    iconBg: 'rgba(79, 70, 229, 0.08)',
    iconColor: '#4f46e5',
    fontWeight: 500,
    fontSize: '0.78125rem',
    minHeight: 34,
    py: 0.2,
    mb: 0.5,
  },
  2: {
    border: '1px solid #e2e8f0',
    borderRadius: '6px',
    bgcolor: '#ffffff',
    iconBg: 'rgba(14, 165, 233, 0.08)',
    iconColor: '#0284c7',
    fontWeight: 500,
    fontSize: '0.75rem',
    minHeight: 32,
    py: 0.15,
    mb: 0.35,
  },
};

export const DEFAULT_TREE_LEVEL_STYLE = {
  border: '1px solid #e2e8f0',
  borderRadius: '6px',
  bgcolor: '#ffffff',
  iconBg: 'rgba(100, 116, 139, 0.08)',
  iconColor: '#64748b',
  fontWeight: 500,
  fontSize: '0.75rem',
  minHeight: 32,
  py: 0.15,
  mb: 0.35,
};

export const ACTION_BUTTON_COLORS = {
  edit: {
    color: '#0284c7',
    hoverBg: 'rgba(2, 132, 199, 0.1)',
  },
  delete: {
    color: '#ef4444',
    hoverBg: 'rgba(239, 68, 68, 0.1)',
  },
  add: {
    color: '#10b981',
    hoverBg: 'rgba(16, 185, 129, 0.1)',
  },
} as const;
